<template>
  <div class="class-record">
    <template v-if="recordData.length > 0">
      <div class="single-card" v-for="item in recordData">
        <div class="title">{{item.title}}</div>
        <div v-if="item.isPassed" class="passed ta--border-right-success ta--border-top-success">
          <i class="mdi mdi-check"></i>
        </div>
        <div v-else class="no-passed ta--border-right-warning ta--border-top-warning">
          <i class="mdi mdi-close"></i>
        </div>
        <div class="info-container">
          <div class="time">学习时间：{{item.startTime}}-{{item.endTime}}</div>
          <div class="info-group">
            <div class="info-item" v-for="info in item.studyData">
              <ProgressCircular
                :value="info.progress"
                width="50"
                weight="6"
                fontSize="12"
                :color="info.color"
                :isLock="info.lock"
                :text="info.type == 'per' ? `${info.progress}%` : info.progress"
                fontColor="#000"
              />
              <div class="info-title">{{info.name}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="more ta--text-primary" v-if="!endData" @click="tapMore">
        <span>加载更多</span>
      </div>
    </template>
    <div class="empty" v-else>
      <i class="icon mdi mdi-book-open-variant"></i>
      <span>您还没有完成任何课程</span>
    </div>
  </div>
</template>

<script>
  import formatTime from "@/utils/formatTime.js"
  import ProgressCircular from '@/components/ProgressCircular'
  export default {
    name: "ClassRecord",
    data() {
      return {
        recordData: [],
        offset: 0,
        count: 10,
        endData: false,
        successColor: '#2196f3',
      }
    },
    components: {
      ProgressCircular,
    },
    beforeMount() {
      let successMap = {
        'normal': '#2196f3',
        'green': '#00BB2C',
      }
      let s = location.search.slice(1), sp = s.split('&'), q = {}
      sp.forEach(sl => {
        let slp = sl.split('=')
        q[slp[0]] = slp[1]
      })
      if(q.theme && successMap[q.theme]){
        this.successColor = successMap[q.theme]
      }

      this.getClassRecord()
    },
    methods: {
      getClassRecord(offset = 0){
        this.$axios.get(`/m/home/my/clazz/list/no/actives/${offset}/${this.count}`)
          .then(resp => {
            let data = resp.data
            if(data && data.status == 'ok' && data.message){
              let m = data.message
              // console.log(m)
              let dataTmp = m.map(d => {
                let studyData = []
                /* 必学 */
                if(d.rule.reqNum > 0) {
                  studyData.push({
                    name: d.clazz.trackType == 2 ? '必学' : '课件',
                    progress: d.sc.reqProgress,
                    color: d.sc.reqProgress == 100 ? this.successColor : '#999',
                    type: 'per'
                  })
                }
                /* 选学 */
                if(d.rule.optNum > 0) {
                  studyData.push({
                    name: d.clazz.trackType == 2 ? '选学' : '选学',
                    progress: d.sc.optProgress,
                    color: d.sc.optProgress == 100 ? this.successColor : '#999',
                    type: 'per'
                  })
                }
                /* 测评 */
                if(d.rule.quizNum > 0) {
                  studyData.push({
                    name: '测评',
                    progress: d.sc.quizProgress,
                    color: d.sc.quizProgress == 100 ? this.successColor : '#999',
                    type: 'per'
                  })
                }
                /* 阅读 */
                if(d.clazz.readJoinExam) {
                  studyData.push({
                    name: '阅读',
                    progress: d.sc.readProgress,
                    color: d.sc.readProgress == 100 ? this.successColor : '#999',
                    type: 'per'
                  })
                }
                return {
                  title: d.clazz.name,
                  startTime: formatTime(d.sc.startTime, 'ignoreTime'),
                  endTime: formatTime(d.sc.endTime, 'ignoreTime'),
                  isStart: Date.now() > d.sc.startTime && Date.now() < d.sc.endTime,
                  studyData: studyData,
                  cid: d.clazz.id,
                  isPassed: d.sc.passed,
                }
              })
              this.recordData = this.recordData.concat(dataTmp)
              if(m.length < this.count){
                this.endData = true
              }
            }
          })
      },
      tapMore() {
        let offset = parseInt(this.offset) + parseInt(this.count)
        this.getClassRecord(offset)
        this.offset = offset
      }
    }
  }
</script>

<style lang="scss" scoped>
  .class-record {
    .empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 50px 0;
      .icon {
        font-size: 60px;
        line-height: 1;
        color: #C7C7CC;
      }
      span {
        color: #666;
        font-size: 12px;
        margin-top: 10px;
      }
    }
    .single-card {
      background: #fff;
      margin: 0 15px;
      margin-top: 15px;
      text-align: left;
      position: relative;

      .passed,
      .no-passed{
        height: 0;
        width: 0;
        border: 24px solid $success;
        /*border-color: var(--success);*/
        position: absolute;
        right: 0;
        top: 0;
        border-bottom-color: transparent;
        border-left-color: transparent;
        .mdi {
          color: #fff;
          position: absolute;
          font-size: 20px;
          top: -20px;
          left: 0;
        }
      }
      .no-passed {
        border-top-color: $warning;
        /*border-top-color: var(--warning);*/
        border-right-color: $warning;
        /*border-right-color: var(--warning);*/
      }

      .title {
        font-size: 16px;
        line-height: 46px;
        padding: 0 15px;
        border-bottom: 1px solid #EFEFF4;
      }
      .info-container {
        padding: 10px 15px 15px;
        .time {
          color: #666666;
          font-size: 12px;
        }
        .info-group {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 10px;
          .info-item {
            margin-right: 20px;
            .info-title {
              color: #666666;
              font-size: 12px;
              text-align: center;
              margin-top: 5px;
            }
            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
    .more {
      font-size: 14px;
      color: $primary;
      /*color: var(--primary);*/
      line-height: 54px;
      margin-top: 10px;
    }
  }
</style>
